<template>
    <div class="upload">
        <h2>Upload Analytic</h2>
        <input v-model="sentera_id" type="text" placeholder="Analytic Sentera ID" />
        <button @click="submit">Submit</button>
    </div>
</template>

<script>
import { uploadAnalytic } from '../utils/api_endpoints';

export default {
    data: function () {
        return {
            sentera_id: ''
        };
    },

    methods: {
        async submit(){
            await uploadAnalytic(this.sentera_id);
        }
    },
};
</script>

<style scoped>
.upload {
    margin-top: 95px;
}

</style>
